import { render, staticRenderFns } from "./TestbankTable.vue?vue&type=template&id=606ff75a&scoped=true&"
import script from "./TestbankTable.vue?vue&type=script&lang=js&"
export * from "./TestbankTable.vue?vue&type=script&lang=js&"
import style0 from "./TestbankTable.vue?vue&type=style&index=0&id=606ff75a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606ff75a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('606ff75a')) {
      api.createRecord('606ff75a', component.options)
    } else {
      api.reload('606ff75a', component.options)
    }
    module.hot.accept("./TestbankTable.vue?vue&type=template&id=606ff75a&scoped=true&", function () {
      api.rerender('606ff75a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Testbank/TestbankTable.vue"
export default component.exports